import {
    ConfirmSignIn,
    ConfirmSignUp,
    SignUp,
    VerifyContact,
    withAuthenticator,
} from 'aws-amplify-react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import MySignIn from './components/security/MySignIn'
import ResetPassword from './components/security/ResetPassword'
import { DEFAULT_LOCATION, CATALOG_PATH, EDIT_ITEM_PATH } from './Constants'
import { setUserData, isFilesOnly, isNormalUser, isPlatformAdmin } from './Utils/ServerUtil'
import AppLayout from './components/layout/AppLayout'
import PrivilegeRoute from './fhg/security/PrivilegeRoute'
import EvalDashboard from './components/eval/dashboard/EvalDashboard'
import UsersGroupsMain from './admin/UsersGroupsMain'
import Support from './support/Support'
import EquipmentListMain from './components/eval/list/EquipmentListMain'
import ValuationMain from './components/eval/list/ValuationMain'
import { configureAmplify } from './config/amplify'
import UpdateAvailableDialog from './components/UpdateAvailableDialog'
import VersionMismatchAlert from './components/eval/components/VersionMismatchAlert'
import { isLocalhost } from './fhg/utils/Utils'
import { initializeVersionChecking, checkVersions } from './config/versionCheck'
import { initializeUserServices } from './config/userInitialization'
import config from './config/runtime'

// Configure AWS Amplify
configureAmplify()

class App extends Component {
    interval

    constructor(props, context) {
        super(props, context)

        this.state = {
            updateAvailable: undefined,
        }

        setUserData(get(props, 'authData'))

        // Initialize user services (Intercom, PostHog, Sentry)
        initializeUserServices(props.authData)

        // Initialize version checking
        this.interval = initializeVersionChecking(
            this.checkVersions,
            config.BUILD_VERSION,
            (newVersion) => {
                clearInterval(this.interval)
                this.setState({ updateAvailable: newVersion })
            }
        )
    }

    static childContextTypes = {
        authData: PropTypes.object,
    }

    getChildContext() {
        return {
            authData: this.props.authData,
        }
    }

    checkVersions = async () => {
        await checkVersions(
            config.BUILD_VERSION,
            (newVersion) => {
                clearInterval(this.interval)
                this.setState({ updateAvailable: newVersion })
            }
        )
    }

    render() {
        const redirectPath = isFilesOnly() ? '/valuation' : DEFAULT_LOCATION
        const { updateAvailable } = this.state

        return (
            <div className="App">
                {updateAvailable && (
                    <VersionMismatchAlert version={updateAvailable} />
                    // <UpdateAvailableDialog
                    //     version={updateAvailable}
                    //     open={true}
                    // />
                )}
                <div className={'main-style'}>
                    <Switch>
                        <Route
                            exact
                            path="/"
                            render={() => <Redirect to={redirectPath} />}
                        />
                        <Route
                            exact
                            path="/login"
                            render={(props) => (
                                <MySignIn
                                    {...props}
                                    authState={this.props.authState}
                                    authData={this.props.authData}
                                    hide={this.props.hide}
                                    onAuthEvent={this.props.onAuthEvent}
                                    onStateChange={this.props.onStateChange}
                                />
                            )}
                        />
                        <Redirect
                            from="/evaluations/owner/:owner?/id/:id?"
                            to="/evaluations/:owner%7C:id"
                        />
                        <Route
                            path={"/*"}
                            render={({ location }) => (
                                <AppLayout 
                                    isNewVersionAvailable={updateAvailable ? true : false}
                                    showAppBar={true}
                                >
                                    <Switch>
                                        <PrivilegeRoute
                                            hasPrivilege={isNormalUser()}
                                            exact
                                            path="/evaluations/all/open"
                                            component={EvalDashboard}
                                        />
                                        <PrivilegeRoute
                                            hasPrivilege={isPlatformAdmin()}
                                            exact
                                            path="/admin"
                                            component={UsersGroupsMain}
                                        />
                                        <PrivilegeRoute
                                            hasPrivilege={isNormalUser()}
                                            exact
                                            path="/support"
                                            component={Support}
                                        />
                                        <PrivilegeRoute
                                            hasPrivilege={isNormalUser()}
                                            exact
                                            path={EDIT_ITEM_PATH}
                                            render={(routeOptions) => (
                                                <EquipmentListMain 
                                                    viewMode="edit"
                                                    routeOptions={routeOptions}
                                                />
                                            )}
                                        />
                                        <PrivilegeRoute
                                            hasPrivilege={isNormalUser()}
                                            exact
                                            path={CATALOG_PATH}
                                            render={(routeOptions) => (
                                                <EquipmentListMain 
                                                    viewMode="catalog"
                                                    routeOptions={routeOptions}
                                                />
                                            )}
                                        />
                                        <PrivilegeRoute
                                            hasPrivilege={isNormalUser()}
                                            exact
                                            path="/new"
                                            render={(routeOptions) => (
                                                <EquipmentListMain 
                                                    viewMode="new"
                                                    routeOptions={routeOptions}
                                                />
                                            )}
                                        />
                                        <PrivilegeRoute
                                            hasPrivilege={isFilesOnly()}
                                            exact
                                            path="/valuation"
                                            component={ValuationMain}
                                        />
                                    </Switch>
                                </AppLayout>
                            )}
                        />
                    </Switch>
                </div>
            </div>
        )
    }
}

const AuthenticatedApp = withAuthenticator(App, false, [
    <MySignIn />,
    <ConfirmSignIn />,
    <VerifyContact />,
    <SignUp />,
    <ConfirmSignUp />,
    <ResetPassword />,
])

export default AuthenticatedApp;